export const TOKEN = "token";

export const DATA_ROOM_TOKEN = "dataRoom";
